import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
export interface ISugMemberParam {
    keywords: string;
    department_id: string;
}
export interface ISugMemberInfo {
    umu_id: string;
    user_name: string;
    avatar?: string;
}
export const getSugMember = (data: ISugMemberParam): Promise<ISugMemberInfo[]> => {
    return fetchData(Api.GET_MEMBER_SUG, data).then((res: IResponse<ISugMemberInfo[]>) => {
        return res.data;
    });
};
